import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'

const useBrowserLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect

/** Reveal below the reader, or on an explicit click. Never move an already
 * visible page just because a deferred recommendation response has arrived. */
export const useRecommendationReveal = (enabled: boolean, ready: boolean) => {
  const anchorRef = useRef<HTMLDivElement>(null)
  const [revealed, setRevealed] = useState(false)
  const reveal = useCallback(() => setRevealed(true), [])

  useBrowserLayoutEffect(() => {
    if (!enabled || !ready || revealed) return
    const viewport = window.visualViewport
    const revealIfBelowViewport = () => {
      const anchor = anchorRef.current
      if (!anchor) return
      const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight
      const top = anchor.getBoundingClientRect().top
      if (Number.isFinite(top) && bottom > 0 && top >= bottom) setRevealed(true)
    }
    revealIfBelowViewport()
    window.addEventListener('scroll', revealIfBelowViewport, { passive: true })
    window.addEventListener('resize', revealIfBelowViewport)
    viewport?.addEventListener('resize', revealIfBelowViewport)
    viewport?.addEventListener('scroll', revealIfBelowViewport)
    return () => {
      window.removeEventListener('scroll', revealIfBelowViewport)
      window.removeEventListener('resize', revealIfBelowViewport)
      viewport?.removeEventListener('resize', revealIfBelowViewport)
      viewport?.removeEventListener('scroll', revealIfBelowViewport)
    }
  }, [enabled, ready, revealed])

  return { anchorRef, showRecommendations: !enabled || revealed, reveal }
}
